// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_o1Q","cls2":"ChatInterface-cls2_Xyr ChatInterface-cls1_o1Q"};